// import { contactFormStyles } from "@insite/content-library/Widgets/ContactUs/ContactForm";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import { MappedLink } from "@nishtech/Overrides/Widgets/Header/MainNavigation";
// import { MappedLink } from "@NA/Overrides/Widgets/Header/MainNavigation";
import React from "react";

interface Props {
    link: MappedLink;
    className?: string;
    href?: string;
    onClick?: (React.MouseEventHandler<HTMLAnchorElement> & ((event: React.MouseEvent<Element, MouseEvent>) => void)) | undefined
    extendedStyles?: LinkPresentationProps;
    dataTestSelector?: string;
    children?: React.ReactNode;
    newLink?: string;
    dealsLink?: string;
    sortBy?: string;
}

const ShopSectionCategoryLink = ({ 
    link,
    className,
    onClick,
    extendedStyles,
    dataTestSelector,
    children,
    newLink,
    dealsLink,
    sortBy
}: Props) => {
    const url = () => {
        if (newLink) {
            return newLink;
        }
        if (dealsLink) {
            return dealsLink;
        }

        return link.url;
    }

    const linkUrl = url();
    const querySymbol = linkUrl?.includes("?") ? "&" : "?";
    const sortByParam = sortBy ? `${querySymbol}sortCriteria=${sortBy}` : '';
    const href = `${linkUrl}${sortByParam}`
    
    return (
        <Link
            className={className}
            {...extendedStyles}
            href={href}
            data-test-selector={dataTestSelector}
            onClick={onClick}
        >
            {children}
        </Link>
    );
};

export default ShopSectionCategoryLink;